<script lang="ts" setup>
import { computed, inject } from 'vue';
import usePortfolio from '../usePortfolio';

import { shortAddress } from '@/helpers/shortAddress';
import { copyToClipboard } from '@/helpers/copyToClipboard';
import BaseAddressSystemIcon from '@/components/BaseAddressSystemIcon.vue';

const { addressesInfo } = inject('portfolioData') as ReturnType<
  typeof usePortfolio
>;

const walletLabel = computed(() => {
  return `${addressesInfo.length} item${addressesInfo.length > 1 ? 's' : ''}`;
});
</script>

<template>
  <v-select
    v-if="addressesInfo.length > 1"
    density="compact"
    hide-details
    class="max-w-[200px] border rounded-jup"
    label="Wallets"
    variant="solo-filled"
    v-model="addressesInfo"
    flat
    :items="addressesInfo"
    item-value="address"
    item-title="address"
    item-disabled="true"
    multiple
    :transition="false"
  >
    <template #prepend-inner>
      <v-icon size="small" class="mr-1">mdi-wallet</v-icon>
    </template>
    <template #item="props">
      <v-list-item v-bind="props" @click="copyToClipboard(props.item.value)">
        <div class="flex items-center gap-4">
          <v-list-item-title class="flex-1">{{
            shortAddress(props.item.value)
          }}</v-list-item-title>
          <v-icon size="14" class="opacity-50" icon="mdi-content-copy">
          </v-icon>
        </div>
      </v-list-item>
    </template>
    <template #selection="{ index }">
      <span class="text-sm" v-if="index === 0"> {{ walletLabel }}</span>
    </template>
  </v-select>
</template>
